var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChpAlt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1246,-22)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.04913,0,0,1.86899,199.71,-1682.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chpAlt",
    transform: "matrix(1,0,0,1,7.84969,6.48236)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.806248,0,0,0.452573,803.37,306.392)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 302.383,
    cy: 1395.21,
    r: 70.807,
    style: {
      fill: "rgb(255,65,0)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.40986,0,0,0.791399,-702.393,579.86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1233.61,476.799C1233.61,476.799 1214.72,474.036 1218.25,454.611C1218.91,446.485 1222.35,439.007 1229.6,432.415C1230.04,440.044 1231.05,445.033 1232.67,447.253C1234.75,435.774 1239.61,424.048 1250.71,417.606C1248.93,420.66 1247.8,425.918 1248.62,430.062C1249.08,432.379 1250.64,436.781 1252.97,440.678C1257.75,448.666 1254.62,452.297 1255.92,452.182C1258.91,447.523 1259.4,443.746 1259.16,439.738C1263.11,444.474 1264.53,449.738 1263.13,462.802C1261.22,472.573 1255.88,478.091 1247.25,479.551L1233.9,476.796L1251.98,457.775L1244.03,457.763L1251.32,439.115L1230.52,461.194L1237.27,461.169L1233.61,476.799Z",
    style: {
      fill: "white",
      stroke: "rgb(255,65,0)",
      strokeWidth: "0.68px"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChpAlt);
export default __webpack_public_path__ + "static/media/chpAlt.c3caebcea69054d5da0e9dac8b513a90.svg";
export { ForwardRef as ReactComponent };